<template>
  <div class="content-general">
    <header-session :complete="false" :isFlutuation="false"/>
    <div class="global-content">
    </div>
    <footer-session />
    <a href="https://api.whatsapp.com/send?phone=5531982669088" target="_blank">
      <icon class="contact-whatsapp" description="rep-social-whatsapp-circle" large />
    </a>
  </div>
</template>

<script>
export default {
  name: 'management-client',
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .content-general
    width: 100%
    height: 100%
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    .global-content
      width: 1200px
      margin: 0 auto
      display: flex
      flex-wrap: wrap
      justify-content: space-between
      align-items: flex-start
      padding-top: 24px !important
      padding-bottom: 80px !important
      p
        text-align: justify
    .contact-whatsapp
      position: fixed
      bottom: 32px
      right: 32px
      fill: #64b060
      background: $white
      border-radius: 50%
    @media (max-width: $widthPrimarySmall)
      .global-content
        width: 100%
        padding: 4px 20px
</style>
